const settings = {
    useMocks: false,
};

export default settings;
